import ApiCalls from 'app/utils/apiCalls';

const syncFlatPanelKindWithBackEnd = ({ state: detectorKind } = {}) => {
  if (detectorKind) {
    ApiCalls.setUserDetectorKind(detectorKind);
  }
};

export default syncFlatPanelKindWithBackEnd;
